import { MaxmindResponse } from 'embed/constants/maxmind'
import MaxMindGeolocator, { isMaxmindResponse } from 'common/services/MaxMindGeolocator'

/**
 * A common location object we can use to abstract away the geolocation provider
 */
export interface CommonLocation {
  zipcode: string
  city: string
  state: string
}

/**
 * Converts Maxmind repsonses to CommonLocations
 */
export const convertMaxmindGeolocation = (maxmindResponse: MaxmindResponse): CommonLocation | undefined => {
  if (isMaxmindResponse(maxmindResponse)) {
    return {
      city: maxmindResponse.city.names.en,
      state: maxmindResponse.subdivisions[0].iso_code,
      zipcode: maxmindResponse.postal.code,
    }
  }
  return
}

/**
 * Returns a CommonLocation from Maxmind
 */
export const getGeoFromIP = (): Promise<CommonLocation | undefined> =>
  MaxMindGeolocator.getGeoFromIP().then(convertMaxmindGeolocation)
